import { useCallback, useEffect, useState } from "react";
import CategoryListTable from "./CategoryListTable";
import { toast } from "react-toastify";
import Loader from "../Common/Loader";
import { useAppSelector } from "../../Reducers/store";
import AddCategoryModal from "./AddCategoryModal";
import CommonApi from "../../Api/CommonApi";
import { CategoryCustom } from "../../Models/CategoryCustom";

export default function CategoryList() {
  const { userModel } = useAppSelector((state) => state.user);
  const [categoryListData, setCategoryListData] = useState<CategoryCustom[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showAddCategory, setShowAddCategory] = useState<boolean>(false);

  const getCategories = useCallback(() => {
    if (userModel) {
      try {
        setIsLoading(true);
        return CommonApi.getCategoriesCustom()
          .then((res) => {
            setCategoryListData(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error("Error loading categories");
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error("Error loading categories");
        setIsLoading(false);
      }
    }
  }, [userModel]);

  useEffect(() => {
    setTimeout(() => {
      getCategories();
    }, 100);
  }, []);

  return (
    <>
      <div className="w-full">
        <div className="w-full h-[74px] p-4">
          <div className="mx-1 flex items-end">
            <div className="flex flex-1">
              <h1 className="text-gray-900 font-bold text-4xl">
                <div>Categories</div>
              </h1>
            </div>
          </div>
        </div>
        <div className="relative">
          {isLoading && <Loader />}
          <div className="w-full p-4 h-[calc(100vh-132px)] md:h-[calc(100vh-200px)] overflow-y-auto">
            <CategoryListTable
              data={categoryListData}
              onRefresh={getCategories}
            />
          </div>
        </div>
      </div>
      <AddCategoryModal
        show={showAddCategory}
        setShow={setShowAddCategory}
        getCategories={getCategories}
      />
    </>
  );
}
